import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEventLocations } from "../redux/eventLocation/eventLocationSlice";

const useLocationOptions = () => {
    const dispatch = useDispatch();
    const { locations = [] } = useSelector((state) => state.eventLocation);

    useEffect(() => {
        if (!locations.length) {
            dispatch(getEventLocations());
        }
    }, [dispatch, locations.length]);

    const options = locations.map((loc) => ({
        value: loc.id,
        label: loc.name,
    }));

    return { options, locations };
};

export default useLocationOptions;